import { useStyles } from './styles'

export const Discount = ({ value = 10 }: { value: number }) => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <span>-{value}%</span>
    </div>
  )
}
